export default __webpack_public_path__ + "static/media/Restore.99771411.svg";